import Error404 from "./Error404";
import DocumentError404 from "./DocumentError404";
import DocumentErrorRecipient404 from "./DocumentErrorRecipient404";

export default Error404;
export { DocumentError404, DocumentErrorRecipient404 };
